export default __webpack_public_path__ + "static/media/producto-02.33859718.jpg";